import type { JSX } from 'react';

export function ExpiredPage(): JSX.Element {
  return (
    <main className="co-container">
      <div className="co-card co-center">
        <h1>Session Expired</h1>
        <p className="co-muted">
          This payment session has expired. Your card has not been charged.
          Please return to the originating product to start a new session.
        </p>
      </div>
    </main>
  );
}
